
    import './styles.scoped.css';
    export default {
  "item-element": "awsui_item-element_93a1u_1t5tb_5",
  "disabled": "awsui_disabled_93a1u_1t5tb_15",
  "last": "awsui_last_93a1u_1t5tb_22",
  "highlighted": "awsui_highlighted_93a1u_1t5tb_25",
  "variant-icon": "awsui_variant-icon_93a1u_1t5tb_29",
  "variant-normal": "awsui_variant-normal_93a1u_1t5tb_29",
  "variant-primary": "awsui_variant-primary_93a1u_1t5tb_29",
  "variant-navigation": "awsui_variant-navigation_93a1u_1t5tb_39",
  "first": "awsui_first_93a1u_1t5tb_42",
  "has-category-header": "awsui_has-category-header_93a1u_1t5tb_42",
  "menu-item": "awsui_menu-item_93a1u_1t5tb_56",
  "icon": "awsui_icon_93a1u_1t5tb_74",
  "external-icon": "awsui_external-icon_93a1u_1t5tb_79"
};
  